import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { CancelRounded, DeleteForeverRounded } from '@mui/icons-material';
import { Instruments } from '@/shared/i18n';
import { InstrumentsLoading, useInstrumentsStore } from '../../store/instruments-store';

interface DeleteConfirmationDialogProps {
  open: boolean;
  imageSrc?: string;
  name?: string;
  onClose: () => void;
  onConfirm: () => void;
  dict: Instruments;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  imageSrc,
  name,
  onClose,
  onConfirm,
  dict,
}) => {
  const { isLoading: isLoadingStore } = useInstrumentsStore();
  const isLoading = isLoadingStore === InstrumentsLoading.DELETE;
  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ width: '100%' }}
    >
      <DialogTitle id="alert-dialog-title" className="flex justify-between" component="div">
        <Typography variant="h5" component="h5">
          {dict.instruments.dialog_title}
        </Typography>
        <CancelRounded className="text-action-divider cursor-pointer" onClick={onClose} />
      </DialogTitle>
      <DialogContent>
        <Box className="bg-background rounded-xl flex items-center gap-6 h-[120px] p-4">
          <img
            src={imageSrc}
            alt={`${name} instrument`}
            className="w-[48px] h-[48px] md:h-[72px] md:w-[72px]"
          />
          <Typography variant="h5">{name}</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          <Typography variant="button-m"> {dict.instruments.dialog_discard}</Typography>
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isLoading}
          color="error"
          className="gap-1 shadow-none"
        >
          {isLoading ? (
            <CircularProgress size={12} color="inherit" />
          ) : (
            <>
              <DeleteForeverRounded className="h-[16px] w-[16px]" />
              <Typography variant="button-m">{dict.instruments.dialog_delete}</Typography>
            </>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
